import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';

type MessageProps = {
  avatar?: ReactNode;
  name: string;
  isBot?: boolean;
  verified?: boolean;
  time?: string;
  continuation?: boolean;
  children: ReactNode;
};

export function Message({
  avatar,
  name,
  isBot = false,
  verified = false,
  time,
  continuation = false,
  children,
}: MessageProps) {
  const t = useTranslations('home.discord');
  return (
    <div className={`msg ${continuation ? 'continuation' : ''}`}>
      {continuation ? <div /> : avatar}
      <div className="body">
        {!continuation && (
          <div className="head">
            <span className={`name ${isBot ? 'bot' : ''}`}>{name}</span>
            {isBot && (
              <span className={`badge-bot${verified ? ' is-verified' : ''}`}>{t('appBadge')}</span>
            )}
            <span className="ts">{time ?? t('defaultTime')}</span>
          </div>
        )}
        <div className="text">{children}</div>
      </div>
    </div>
  );
}
